import $ from 'jquery'

export function PatientInfo(ditaHTML,dartSelectors){
   $("#patientId table").hide()
   $(ditaHTML).find("table").each(function(index,element){
       $("#patientId").append(element);
   });
   ProcessPdfXref(dartSelectors);
   
}


function ProcessPdfXref(dartSelectors){
   $("xref").before('<i class="fa fa-file-pdf-o red"></i> ');
   $("xref").on({
       click:function(){
           let selectedXref = this;
           let pdfLink = $(selectedXref).attr("href").replace("../PDF",`https://ccmsfiles.tg.org.au/${process.env.REACT_APP_CCMS_VERSION}/PDF`);
            //    window.open(pdfLink);
               let tgPdfViewer = document.querySelector('#tgpdfviewer');
               let tgPDFIframe = document.querySelector('#tgpdfviewer iframe');
               let modalBackdrop = document.querySelector('.modal-backdrop');
               // modalBackdrop.style.display = 'block';
               if(!tgPdfViewer.classList.contains('in')){
                 tgPdfViewer.classList.toggle('in');
                 tgPDFIframe.src = pdfLink;
                 let pdfFileName = (pdfLink.indexOf("/")===-1)?pdfLink:pdfLink.split("/").slice(-1)[0];
                 dartSelectors.iDB.read(pdfFileName).then((value) => {
                   if (value) {
                     pdfLink = value;
                   }
                //    console.log(pdfLink);
                   tgPdfViewer.style.display = 'block';
                   if(modalBackdrop===undefined){
                     modalBackdrop.style.display = 'block';
                     modalBackdrop.classList.toggle('in');
                   }
                 });
               }
       }
   });
}

